import { db } from "../../../config/firebaseconfig"
import uuid from 'uuid/v1'

export default function addAccountLicense ({ 
  startDate, 
  endDate, 
  quantity, 
  licenseSet, 
  licenseType,
  district,
  accountId,
  navName,
  navCategory,
  name,
  id
}) {
  const identifier = id || uuid()
  return db.collection('accountLicenses').doc(identifier).set({
    id: identifier,
    startDate,
    endDate,
    licensedMax: quantity,
    licenseSet,
    licensedUsers: {},
    licensedCount: 0,
    licenseType,
    district,
    accountId,
    created: Date.now(),
    lastModified: Date.now(),
    navName,
    navCategory,
    name,
  })
}


/*

	x Start timestamp
	x Expiration timestamp
	x LicenseSet (pointing to the Set flagged as LicenseSet)
	x LicensedUsers (the users who are using the licenses)
	x LicenseCount (the number licensed users)
	x LicenseCountMax (the maximum number of allowed license uses) 
	x LicenseRole (either student or admin)
	accountId
  districtId (can be same as accountId)

*/


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/addAccountLicense.js